import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useURLSearchParams = () => {
  const [searchParams, setSearchParams] = useState({});
  const { pathname, search } = useLocation();

  useEffect(() => {
    let obj = {};
    let urlSearchParams = new URLSearchParams(search);
    urlSearchParams.forEach((value, key) => {
      obj[key] = value;
    });
    setSearchParams(obj);
  }, [pathname, search]);

  return searchParams;
};



//old interval method ,....
/**gets the user location and fires some usefull events that you can listen .
 * @param autoGet if true , hook will automatically get the position
 * @event get-location
 * @event retrived-position
 * @event error-position
 * @event location-on
 * @event location-off
 */
export const useDeviceLocation = (autoGet) => {
  const [location, setLocation] = useState(null);
  const [locationGetSuccess, setLocationGetSuccess] = useState(null);
  const eventTypes = {
    getLocation: "get-location",
    retrivedLocation: "retrived-location",
    errorLocation: "error-location",
    locationOn: "location-on",
    locationOff: "location-off",
  };

  /**attemps to get the location and set location  */
  const getLocation = () => {
    if (navigator?.geolocation) {
      fireEvent(eventTypes.getLocation);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation(position.coords);
          fireEvent(eventTypes.retrivedLocation, position.coords);
        },
        (e) => {
          fireEvent(eventTypes.errorLocation, e.message);
        }
      );
      return {
        location: location,
      };
    }
  };

  /**you can also use this to fire your own custom event */
  const fireEvent = (type, data) =>
    window.dispatchEvent(new CustomEvent(type, { detail: data }));

  /**if you dont want to listen for event by custom code , use this  */
  const addEventListener = (type, listener) => {
    window.addEventListener(type, listener);
  };

  /**this will be called after 1s to listen for on or off of location */
  const checkOnOff = () => {
    if (navigator?.geolocation) {
      navigator.geolocation.getCurrentPosition(
        () => {
          setLocationGetSuccess(true);
        },
        (e) => {
          setLocationGetSuccess(false);
        }
      );
    }
  };

  useEffect(() => {
    let interval = setInterval(() => {
      checkOnOff();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (locationGetSuccess !== null) {
      if (!locationGetSuccess)
        fireEvent(eventTypes.locationOff, "location is off");
      else fireEvent(eventTypes.locationOn, "location is on");
    }
  }, [locationGetSuccess]);

  useEffect(() => {
    if (autoGet) getLocation();
  }, [autoGet]);

  return { location, eventTypes, fireEvent, addEventListener, getLocation };
};




//new bugged methid.....
/**
 * Gets the user location and fires useful events that you can listen for.
 * @param {boolean} autoGet - If true, hook will automatically get the position
 * @event get-location
 * @event retrived-location
 * @event error-location
 * @event location-on
 * @event location-off
 */
// export const useDeviceLocation = (autoGet) => {
//   const [location, setLocation] = useState(null);
//   const [locationGetSuccess, setLocationGetSuccess] = useState(null);
//   const [watchId, setWatchId] = useState(null);

//   const eventTypes = {
//     getLocation: "get-location",
//     retrivedLocation: "retrived-location",
//     errorLocation: "error-location",
//     locationOn: "location-on",
//     locationOff: "location-off",
//   };

//   /** Utility to dispatch events globally */
//   const fireEvent = (type, data) =>
//     window.dispatchEvent(new CustomEvent(type, { detail: data }));

//   /** Utility to add listener from external code */
//   const addEventListener = (type, listener) => {
//     window.addEventListener(type, listener);
//   };

//   /** Attempts to get location once */
//   const getLocation = () => {
//     if (navigator?.geolocation) {
//       fireEvent(eventTypes.getLocation);
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setLocation(position.coords);
//           fireEvent(eventTypes.retrivedLocation, position.coords);
//         },
//         (e) => {
//           fireEvent(eventTypes.errorLocation, e.message);
//         }
//       );
//       return { location };
//     }
//   };

//   /** Start watching for location changes */
//   const startWatching = () => {
//     if (!navigator?.geolocation) return;

//     fireEvent(eventTypes.getLocation);

//     const id = navigator.geolocation.watchPosition(
//       (position) => {
//         // Keep structure same as navigator.geolocation
//         const coords = position.coords;
//         setLocation(coords);
//         setLocationGetSuccess(true);
//         fireEvent(eventTypes.retrivedLocation, coords);
//       },
//       (error) => {
//         setLocationGetSuccess(false);
//         fireEvent(eventTypes.errorLocation, error.message);
//       }
//     );

//     setWatchId(id);
//   };

//   /** Stop watching for location changes */
//   const stopWatching = () => {
//     if (watchId && navigator?.geolocation) {
//       navigator.geolocation.clearWatch(watchId);
//       setWatchId(null);
//     }
//   };

//   useEffect(() => {
//     if (autoGet) {
//       startWatching();
//     }

//     return () => {
//       stopWatching();
//     };
//   }, [autoGet]);

//   /** React to location on/off */
//   useEffect(() => {
//     if (locationGetSuccess !== null) {
//       if (!locationGetSuccess)
//         fireEvent(eventTypes.locationOff, "location is off");
//       else fireEvent(eventTypes.locationOn, "location is on");
//     }
//   }, [locationGetSuccess]);

// console.log("Device location....",location);


//   return {
//     location,
//     eventTypes,
//     fireEvent,
//     addEventListener,
//     getLocation,
//     startWatching,
//     stopWatching,
//   };
// };



